import cn from 'classnames';
import { Modal } from 'react-bootstrap';
import { MdClose } from 'react-icons/md';
import { IconButton } from '@Components/IconButton';
import { CreativeThumb } from './CreativeSuiteShared';
import { GALLERY_CREATIVES, GALLERY_TITLE, GalleryCreative } from './creativeSuite-constants';

const RISK_TAG: Record<GalleryCreative['risk'], string> = {
  green: 'tag-green',
  amber: 'tag-amber',
  red: 'tag-red'
};

const GalleryCard = ({ creative }: { creative: GalleryCreative }) => (
  <div className={cn('gallery-card', creative.risk)}>
    <div className='gallery-preview'>
      <CreativeThumb kind={creative.kind} />
      <span className={cn('tag', RISK_TAG[creative.risk])}>{creative.fatigue}</span>
    </div>
    <div className='gallery-meta'>
      <div className='gallery-name'>{creative.name}</div>
      <div className='gallery-stats'>
        CTR {creative.ctr} · CPA {creative.cpa}
      </div>
    </div>
  </div>
);

export const CreativeGalleryModal = ({ show, onHide }: { show: boolean; onHide: () => void }) => (
  <Modal show={show} onHide={onHide} centered dialogClassName='creative-gallery-modal'>
    <div className='gallery-head'>
      <div>
        <div className='gallery-title'>Creatives · {GALLERY_TITLE}</div>
        <div className='gallery-subtitle'>
          {GALLERY_CREATIVES.length} active · sorted by fatigue
        </div>
      </div>
      <IconButton onClick={onHide}>
        <MdClose aria-hidden />
      </IconButton>
    </div>
    <div className='gallery-grid'>
      {GALLERY_CREATIVES.map(creative => (
        <GalleryCard key={creative.name} creative={creative} />
      ))}
    </div>
  </Modal>
);
